export const themes = {

  blue: {
    primary: "#2563eb",
    success: "#198754",
    danger: "#dc3545",
    warning: "#ffc107",
    info: "#0dcaf0",
    purple: "#6f42c1",
    navbar: "#ffffff",
    sidebar: "#1e293b",
    text: "#1e293b",
    textwhite: "#ffffff",
    border: "#dbe4ee",
    background: "#f5f7fb",
    card: "#ffffff",
    sidebarText: "#ffffff",
    radius: "4px",
  },

  green: {
    primary: "#198754",
    sidebar: "#146c43",
    navbar: "#198754",
    background: "#eef9f0",
    card: "#ffffff",
    text: "#212529",
    textwhite: "#ffffff",
    radius: "4px",
  },

  purple: {
    primary: "#6f42c1",
    sidebar: "#5b34a1",
    navbar: "#6f42c1",
    background: "#f7f3ff",
    card: "#ffffff",
    text: "#212529",
    textwhite: "#ffffff",
    radius: "4px",
    purple: "#6f42c1",
    olive:"#687c00",
  },

  red: {
    primary: "#dc3545",
    sidebar: "#b02a37",
    navbar: "#dc3545",
    background: "#fff5f5",
    card: "#ffffff",
    text: "#212529",
    textwhite: "#ffffff",
    radius: "4px",
  },
};
